export default __webpack_public_path__ + "static/media/linkedin.0904bc36.svg";